import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type Translate = (key: string, values?: Record<string, string | number>) => string;

/** Bound to the single `owner` namespace. Stable per language, so it can sit in dependency lists. */
export const useT = (): Translate => {
  const { t } = useTranslation('owner');
  return useCallback<Translate>((key, values) => t(key, values ?? {}), [t]);
};

/** The `Intl` locale for the active language; English dates read day-first like the Norwegian. */
export const useLocale = (): string => {
  const { i18n } = useTranslation('owner');
  return i18n.language === 'nb' ? 'nb-NO' : 'en-GB';
};
